export default {
  title: 'Cradlepoint Video'
}

const Template = args => `
  <cradlepoint-container>
    <cradlepoint-video 
    video-url="${args['videoUrl']}" 
    bg-image="${args['bgImage']}" 
    width="${args['width']}" 
    aspect-ratio="${args['aspectRatio']}" 
    popup-width="${args['popupWidth']}"
    max-width="${args['maxWidth']}"
  >
    </cradlepoint-video>
  </cradlepoint-container>
`;

export const CradlepointVideoDefault = Template.bind({});
export const CradlepointVideoCustomBgImage = Template.bind({});

CradlepointVideoDefault.args = {
  videoUrl: 'https://www.youtube-nocookie.com/embed/Ry7ub29fdlI',
  bgImage: '',
  width: '100%',
  aspectRatio: '16:9',
  popupWidth: '100%',
  maxWidth: '1280px',
}

CradlepointVideoCustomBgImage.args = {
  videoUrl: 'https://www.youtube-nocookie.com/embed/Ry7ub29fdlI',
  bgImage: 'https://img.cradlepoint.com/auto-mapping-folder/2020/03/about-us-story-img.webp',
  width: '100%',
  aspectRatio: '16:9',
  popupWidth: '100%',
  maxWidth: '1280px',
}
